'use client';

import { useEffect, useRef, useState } from 'react';
import * as Styled from './BurgerTwoLines.styles';

export const BurgerTwoLines = ({ isOpen = false }: { isOpen: boolean }) => {
  const prevIsOpen = useRef<boolean | undefined>(undefined);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    // On the very first run, just set the previous value and don't animate
    if (prevIsOpen.current === undefined) {
      prevIsOpen.current = isOpen;
      return;
    }

    // Animate only if the value actually changed
    if (prevIsOpen.current !== isOpen) {
      setShouldAnimate(true);
      prevIsOpen.current = isOpen;
    }
  }, [isOpen]);

  return (
    <Styled.Svg
      isOpen={isOpen}
      data-should-animate={shouldAnimate}
      width="39"
      height="7"
      viewBox="0 0 39 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="first-line">
        <line x1="0" y1="3.5" x2="39" y2="3.5" stroke="#10100F" strokeWidth="1" />
      </g>
      <g className="second-line">
        <line x1="0" y1="3.5" x2="39" y2="3.5" stroke="#10100F" strokeWidth="1" />
      </g>
    </Styled.Svg>
  );
};